"use client";
import {
  partnersMock
} from "./chunk-KR2P4YYY.mjs";
import {
  Image_default
} from "./chunk-BVJ4WRGT.mjs";

// src/components/sections/Partnerships/Partnerships.tsx
import React from "react";
import classNames from "classnames";
import { jsx, jsxs } from "react/jsx-runtime";
var PartnerItem = React.memo(
  ({ partner, isMobile = false }) => {
    const { path, width, height, alternativeText } = isMobile ? partner.mobile : partner.web;
    return /* @__PURE__ */ jsx("div", { className: classNames("flex items-center", {}), children: /* @__PURE__ */ jsx("div", { className: "block", children: /* @__PURE__ */ jsx(
      Image_default,
      {
        src: path,
        width,
        height,
        alt: alternativeText,
        "aria-label": alternativeText
      }
    ) }) });
  }
);
PartnerItem.displayName = "PartnerItem";
var PartnershipsComponent = ({
  title,
  partners = partnersMock,
  bg = "bg-display-50"
}) => {
  const defaultTitle = /* @__PURE__ */ jsxs("h2", { className: "font-display text-3xl lg:text-6xl font-bold leading-6 lg:leading-9 text-center", children: [
    "Parceira de mais de",
    " ",
    /* @__PURE__ */ jsx("span", { className: "text-stone-500", children: "4 milh\xF5es de neg\xF3cios" }),
    " por todo Brasil"
  ] });
  return /* @__PURE__ */ jsx("div", { className: classNames("flex justify-center px-24 w-full", bg), children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-24 justify-center items-center pt-40 pb-40 lg:pb-80 w-full max-w-7xl", children: [
    title ? /* @__PURE__ */ jsx(
      "h2",
      {
        dangerouslySetInnerHTML: { __html: title },
        className: "font-display text-3xl lg:text-6xl font-bold leading-6 lg:leading-9 text-center",
        "aria-label": "T\xEDtulo das parcerias"
      }
    ) : defaultTitle,
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(
          "hidden lg:flex flex-wrap sm:gap-x-[110px] md:gap-x-0 justify-between md:py-32 w-full h-[200px] md:h-auto"
        ),
        "aria-label": "Lista de parceiros para desktop",
        children: partners.map((partner, index) => /* @__PURE__ */ jsx(
          PartnerItem,
          {
            partner
          },
          `desktop-${partner.web.height}-${index}`
        ))
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(
          "lg:hidden flex flex-wrap sm:gap-x-[110px] md:gap-x-0 justify-between md:py-32 w-full h-[200px] md:h-auto"
        ),
        "aria-label": "Lista de parceiros para mobile",
        children: partners.map((partner, index) => /* @__PURE__ */ jsx(
          PartnerItem,
          {
            partner,
            isMobile: true
          },
          `mobile-${partner.mobile.id}-${index}`
        ))
      }
    )
  ] }) });
};
var Partnerships_default = React.memo(PartnershipsComponent);

export {
  Partnerships_default
};
